module.exports = "<app-budget-cap-management (back)=\"hideBudgetCap.emit()\">\n</app-budget-cap-management>\n"